import { OrderItemTrackingStatusEnum } from '@models';

export const PAID_TILE_AMOUND = 'Amount paid';
export const PAID_TITLE_REFUND = 'Refund details';
export const PAID_TITLE_BY_STATUS: Record<OrderItemTrackingStatusEnum, string> = {
  [OrderItemTrackingStatusEnum.Ordered]: PAID_TILE_AMOUND,
  [OrderItemTrackingStatusEnum.Shipped]: PAID_TILE_AMOUND,
  [OrderItemTrackingStatusEnum.Delivered]: PAID_TILE_AMOUND,
  [OrderItemTrackingStatusEnum.Returned]: PAID_TITLE_REFUND,
  [OrderItemTrackingStatusEnum.Canceled]: PAID_TITLE_REFUND,
  [OrderItemTrackingStatusEnum.Submitted]: PAID_TITLE_REFUND,
  [OrderItemTrackingStatusEnum.DeliveredInReturn]: '',
  [OrderItemTrackingStatusEnum.PaymentPending]: '',
  [OrderItemTrackingStatusEnum.PaymentFailed]: '',
  [OrderItemTrackingStatusEnum.FraudHeld]: '',
  [OrderItemTrackingStatusEnum.ReturnReceived]: '',
  [OrderItemTrackingStatusEnum.ReturnStarted]: '',
  [OrderItemTrackingStatusEnum.Failed]: '',
  [OrderItemTrackingStatusEnum.Declined]: '',
};

export const TOTAL_AMOUNT_LABEL = 'Total amount';
export const TOTAL_REFUND_LABEL = 'Total amount refunded';
export const TOTAL_LABEL_BY_STATUS: Record<OrderItemTrackingStatusEnum, string> = {
  [OrderItemTrackingStatusEnum.Ordered]: TOTAL_AMOUNT_LABEL,
  [OrderItemTrackingStatusEnum.Shipped]: TOTAL_AMOUNT_LABEL,
  [OrderItemTrackingStatusEnum.Delivered]: TOTAL_AMOUNT_LABEL,
  [OrderItemTrackingStatusEnum.Returned]: TOTAL_REFUND_LABEL,
  [OrderItemTrackingStatusEnum.Canceled]: TOTAL_REFUND_LABEL,
  [OrderItemTrackingStatusEnum.Submitted]: TOTAL_REFUND_LABEL,
  [OrderItemTrackingStatusEnum.DeliveredInReturn]: '',
  [OrderItemTrackingStatusEnum.PaymentPending]: '',
  [OrderItemTrackingStatusEnum.PaymentFailed]: '',
  [OrderItemTrackingStatusEnum.FraudHeld]: '',
  [OrderItemTrackingStatusEnum.ReturnReceived]: '',
  [OrderItemTrackingStatusEnum.ReturnStarted]: '',
  [OrderItemTrackingStatusEnum.Failed]: '',
  [OrderItemTrackingStatusEnum.Declined]: '',
};
